import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";

/**
 * RedirectCountdown - Shows a countdown timer and a "Go Back" button.
 * When the countdown reaches 0, auto-redirects to the given URL.
 *
 * @param {string} redirectUrl - The URL to redirect to
 * @param {number} seconds - Countdown duration in seconds (default: 10)
 */
export default function RedirectCountdown({ redirectUrl, seconds = 10 }) {
  const [countdown, setCountdown] = useState(seconds);
  const { primary_color, primary_text_color } = useSelector((state) => state.style);

  const handleRedirect = useCallback(() => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  useEffect(() => {
    if (!redirectUrl) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [redirectUrl, handleRedirect]);

  if (!redirectUrl) return null;

  return (
    <div className="mt-6 border-t pt-4 text-center space-y-3">
      <p className="text-sm text-gray-500">
        Anda akan dialihkan dalam{" "}
        <span className="font-semibold text-gray-700">{countdown}</span> detik...
      </p>
      <button
        onClick={handleRedirect}
        className="w-full py-3 px-4 rounded-lg font-semibold text-base transition-opacity hover:opacity-90"
        style={{
          backgroundColor: primary_color || "#4F46E5",
          color: primary_text_color || "#FFFFFF",
        }}
      >
        Kembali
      </button>
    </div>
  );
}
